var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('OptionChart',{attrs:{"symbol":"510050"}}),_c('OptionChart',{attrs:{"symbol":"510300"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }